var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9141 6.37891L12.543 5.75L11.9141 5.14844L7.97656 1.21094L7.375 0.582031L6.11719 1.8125L6.74609 2.44141L9.17969 4.875H1.25H0.375V6.625H1.25H9.17969L6.74609 9.08594L6.11719 9.6875L7.375 10.9453L7.97656 10.3164L11.9141 6.37891Z",
    fill: "#EDF5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCat);
export default __webpack_public_path__ + "static/media/arrow_cat.2f01492b12413937742681c0f797e0b5.svg";
export { ForwardRef as ReactComponent };